// extracted by mini-css-extract-plugin
module.exports = {"Heading":"Heading_Heading__p5X7z"};